import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';
import { ANALYTICS, COMMON_CONSTANTS, RATEPLANSERVICE } from 'src/app/common/core/common.constants';
import { ChangeServiceService } from 'src/app/services/change-service.service';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { environment } from 'src/environments/environment';
import { isNullOrUndefined } from 'src/app/services/utils';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { PDLService } from 'src/app/services/pdl-service.service';


@Component({
  selector: 'app-conflicting-modal',
  templateUrl: './conflicting-modal.component.html',
  styleUrls: ['./conflicting-modal.component.scss']
})
export class ConflictingModalComponent implements OnInit {
  authoringContentData: any;
  selectedService: any;
  servicesList: any;
  currentSelectedServices: any;
  currentConflictingServices = [];
  uncheckedK2KService: any;
  k2kPopUp: any;
  k2kAddPopUp: any;
  conflictPopup: any;
  restrictedInReviewTyp: any;
  grandFatherCheck: boolean;
  grandFatherService: any;
  grandFatherPopup: boolean;
  currentServArray:any;
  enableMultiPromo: boolean = false;
  private isk2kEnabled = environment.ENABLE_K2K_SOCS_FLOW;
  selectedSvcName: any;
  conflictSvcName: any;
  restConflictSvcName: any[];
  changeRatePlanFlow: boolean = false;
  zero = COMMON_CONSTANTS.DIGITS.ZERO;
  one = COMMON_CONSTANTS.DIGITS.ONE;
  isServiceChange: boolean = false;
  @Output() confirmChange = new EventEmitter();
  modalTitle:any;
  conflictingRedemptionSocPopup: boolean = false;

  constructor(private _cacheSvc: HttpCacheService, private manageLineSvc: ManageLineService, private changeSvc: ChangeServiceService, private pdlService: PDLService) {
    this.grandFatherCheck = false;
    this.enableMultiPromo = environment.ENABLE_EVALUATE_PROMOTION;
   }

  ngOnInit() {
    this.changeRatePlanFlow = Boolean(JSON.parse(this._cacheSvc.getFromSessionStorage(RATEPLANSERVICE.CHANGE_RATE_PLAN_FLOW))) ? true : false;
    this.authoringContentData = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.CONTENT));
    _.each(this.currentSelectedServices, (item) => {
      if(!this.isk2kEnabled && !item.isk2k && (!item.isNFLX || !item.isHULU)){
        this.callsWhenNotK2K(item);
      }else if(this.isk2kEnabled && (item.isk2k || (item.isNFLX || item.isHULU))){
        this.callsWhenK2k(item);
      }
    });
    this.getCurrentConflictingServices();
    this.setK2kServicesName(this.selectedService);
   this.modalTitle= this.authoringContentData.changeService.incompatibleServiceMsg;
    if (this.restrictedInReviewTyp === COMMON_CONSTANTS.SERVICES.REMOVAL) {
      this.modalTitle=this.authoringContentData.changeService.serviceConflictModalRemoveTitle;
    }else if(this.restrictedInReviewTyp === COMMON_CONSTANTS.SERVICES.ADDITION){
      this.modalTitle=this.authoringContentData.changeService.serviceConflictModalAddTitle;
    }
    let modalInfo = {
      eventAction: ANALYTICS.LOAD,
      modalName:this.modalTitle,
    };
    if(this.changeRatePlanFlow){
      modalInfo['stage'] = this.authoringContentData.changeRatePlan.inProgress
      modalInfo['name'] = this.authoringContentData.changeRatePlan.changeRatePlanText
    }
    this.pdlService.ifEnabledGenerateModalViewTag(modalInfo);
  }

  callsWhenNotK2K(item){
    if(item.grandfathered === COMMON_CONSTANTS.TRUE_TXT || item.grandfatheredFlag === true){
      this.grandFatherCheck = true;
    }
  }

  callsWhenK2k(item){
    if(item.grandfathered === COMMON_CONSTANTS.TRUE_TXT || item.grandfatheredFlag === true){
      this.grandFatherCheck = true;
      this.grandFatherService = item;
    }
  }

  // getting the currently conflicting services for selected service
  getCurrentConflictingServices() {
    if (!isNullOrUndefined(this.selectedService)) {
      const conflictingSocs = <any[]>this.selectedService.currentlyConflictingWith;
      _.each(this.servicesList, (item) => {
        _.each(conflictingSocs, (soc) => {
          if (item.soc === soc) {
            this.currentConflictingServices.push(item);
            if(item.grandfathered === COMMON_CONSTANTS.TRUE_TXT || item.grandfatheredFlag === true){
              this.grandFatherCheck = true;
            }else{
              this.grandFatherCheck = false;
            }
          }
        });
      });
    }
    this.currentConflictingServices = _.uniqBy(this.currentConflictingServices,'soc')
  }
  updateMainList(){
    this.currentSelectedServices = JSON.parse(this._cacheSvc.getFromSessionStorage(RATEPLANSERVICE.CURRENT_SELECTED_SERVICE));
    this.servicesList = JSON.parse(this._cacheSvc.getFromSessionStorage(RATEPLANSERVICE.SERVICE_LIST));
    _.each(this.currentSelectedServices,(currentList)=>{
      _.each(this.servicesList,(servList)=>{
        if(currentList.soc === servList.soc){
          servList.isSelected = currentList.isSelected;
        }
      });
    });
    this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.SERVICE_LIST, JSON.stringify(this.servicesList));
    this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.CURRENT_SELECTED_SERVICE, JSON.stringify(this.currentSelectedServices));
    this.nextButtonEnable();
  }
  nextButtonEnable(){
    let currentServiceList=!isNullOrUndefined(this._cacheSvc.getFromSessionStorage(RATEPLANSERVICE.SERVICE_LIST))?JSON.parse(this._cacheSvc.getFromSessionStorage(RATEPLANSERVICE.SERVICE_LIST)):'';
    let count=0;
    _.each(currentServiceList, (item) => {
      if((!item.current && item.isSelected) || (item.current && !item.isSelected)){
        count++;
      }
    })
    if(count == 0 && !(Boolean(JSON.parse(this._cacheSvc.getFromSessionStorage(RATEPLANSERVICE.IS_PLAN_CHANGE))))){
      this.isServiceChange = false;
      this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.IS_SERVICE_CHANGE ,this.isServiceChange);
      this.confirmChange.emit(true);
    }else{
      if(count==0 && Boolean(JSON.parse(this._cacheSvc.getFromSessionStorage(RATEPLANSERVICE.IS_PLAN_CHANGE)))){
        this.isServiceChange = false;
        this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.IS_SERVICE_CHANGE ,this.isServiceChange);
      }else{
        this.isServiceChange = true;
        this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.IS_SERVICE_CHANGE,this.isServiceChange);
      }
      this.confirmChange.emit(false);
    }
  }
  updateServiceList(){
    _.each(this.servicesList,(servList)=>{
      if(this.selectedService.soc === servList.soc){
        servList.isSelected = this.selectedService.isSelected;
      }
    });
    this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.CURRENT_SELECTED_SERVICE, JSON.stringify(this.currentSelectedServices));
    this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.SERVICE_LIST, JSON.stringify(this.servicesList));
    this.updateMainList();
  }
  onClickClose(event?:any) {
    let buttonName:any;
    if(!isNullOrUndefined(event) && !isNullOrUndefined(event.currentTarget) && !isNullOrUndefined(event.currentTarget.innerText) && event.currentTarget.innerText === this.authoringContentData.changeService.cancelTxt){
     buttonName = this.authoringContentData.changeService.cancelTxt;
    }else{
     buttonName = ANALYTICS.CLOSE;
    }
    this.selectedService.isSelected = !this.selectedService.isSelected;
    if(this.changeRatePlanFlow){
      if (this.currentSelectedServices.find((test) => test.soc === this.selectedService.soc) === undefined) {
        this.currentSelectedServices.push(this.selectedService);
      }
      this.iterateOnCurrentSelectedObj();
      this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.CURRENT_SELECTED_SERVICE, JSON.stringify(this.currentSelectedServices));
      this.updateMainList();
    }
    this.manageLineSvc.close();
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: buttonName ,
      assetType: ANALYTICS.BUTTON,
      modalName:this.modalTitle,
    });
  }

  onK2KClickClose(event?:any) {
    let buttonName:any;
    if(!isNullOrUndefined(event) && !isNullOrUndefined(event.currentTarget) && !isNullOrUndefined(event.currentTarget.innerText) && event.currentTarget.innerText === this.authoringContentData.changeService.cancelTxt){
     buttonName = this.authoringContentData.changeService.cancelTxt;
    }else{
     buttonName = ANALYTICS.CLOSE;
    }
    if (this.k2kAddPopUp) {
      this.onClickClose(event);
    }

    if (this.restrictedInReviewTyp === COMMON_CONSTANTS.SERVICES.REMOVAL) {
      this.selectedService.isSelected = true;
      const temp = _.cloneDeep(this.selectedService);
      this.currentSelectedServices.push(temp);
      this.currentSelectedServices = _.uniqBy(this.currentSelectedServices,'soc');
      if(this.changeRatePlanFlow){
        this.updateServiceList();
      }
      this.changeSvc.serviceSelectionChanged.next(true);
    }

    if (this.restrictedInReviewTyp === COMMON_CONSTANTS.SERVICES.ADDITION) {
      this.selectedService.isSelected = false;
      const temp = _.cloneDeep(this.selectedService);
      const index = this.getIndexOfSocV2(this.currentSelectedServices, temp.soc);
      if(index !== -1){
        this.currentSelectedServices.splice(index, COMMON_CONSTANTS.DIGITS.ONE);
      }
      if(this.changeRatePlanFlow){
        this.updateServiceList();
      }
      this.changeSvc.serviceSelectionChanged.next(true);
    }
    this.manageLineSvc.close();
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: buttonName ,
      assetType: ANALYTICS.BUTTON,
      modalName:this.modalTitle,
    });
  }

  removeAndContinue() {
    let removingCurrentSoc:boolean = false;
    _.each(this.currentConflictingServices, (item) => {
      if((item.currentService === true || item.current === true) && !item.isk2k && (!item.isNFLX || !item.isHULU)){
        removingCurrentSoc = true;
      }
    });
    if(this.enableMultiPromo && removingCurrentSoc){
      const temp = _.cloneDeep(this.selectedService);
      this.currentSelectedServices.push(temp);
      this.selectedService.isSelected = true;
      _.each(this.currentConflictingServices, (item) => {
        if(item.currentService === false || item.current === false){
          /** Removing conflicted eligible services */
          item.isSelected = false;
          const index = this.getIndexOfSocV2(this.currentSelectedServices, item.soc);
          if(index !== -1){
            this.currentSelectedServices.splice(index, COMMON_CONSTANTS.DIGITS.ONE);
          }
        }
      });
      if(this.changeRatePlanFlow){
        this.updateServiceList();
      }
      /** Trigger promo api if the conflicting soc is current service*/
      this.manageLineSvc.close();
      this.changeSvc.triggerPromoApi.next(true);
    }else{
      const temp = _.cloneDeep(this.selectedService);
      this.currentSelectedServices.push(temp);
      this.selectedService.isSelected = true;
      // changing the conflictingServices item will also change allServices item REFERENCE TYPE
      _.each(this.currentConflictingServices, (item) => {
        item.isSelected = false;
        const index = this.getIndexOfSocV2(this.currentSelectedServices, item.soc);
        if(index !== -1){
          this.currentSelectedServices.splice(index, COMMON_CONSTANTS.DIGITS.ONE);
        }
      });
      if(this.changeRatePlanFlow){
        this.updateServiceList();
      }
      this.changeSvc.serviceSelectionChanged.next(true);
      this.manageLineSvc.close();
    }
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: this.authoringContentData.changeService.removeServiceContinueTxt ,
      assetType: ANALYTICS.BUTTON,
      modalName:this.modalTitle,
    });
  }

  getIndexOfSocV2(array: any[], item) {
    let index = -1;
    _.each(array, (service, ind) => {
      if (service.soc === item) {
        index = ind;
      }
    });
    return index;
  }

  setK2kServicesName(service) {
    if (this.k2kAddPopUp) {
      const typeOfSelectedSvc = this.getTypeOfK2kService(service);
      const conflictSvc: any = _.find(this.currentConflictingServices, (item) => { return (item.isk2k || (item.isNFLX || item.isHULU)) && item.isSelected });
      const typeOfConflicSvc = this.getTypeOfK2kService(conflictSvc);
      if (!isNullOrUndefined(conflictSvc && service) && (typeOfSelectedSvc === typeOfConflicSvc)) {
        this.selectedSvcName = service.name ? service.name : service.description;
        this.conflictSvcName = conflictSvc.name ? conflictSvc.name : conflictSvc.description;
      } else {
        this.selectedSvcName = this.getContentFork2kSvc(typeOfSelectedSvc);
        this.conflictSvcName = this.getContentFork2kSvc(typeOfConflicSvc);
      }
    } else {
      const typeOfSelectedSvc = this.getTypeOfK2kService(service);
      this.selectedSvcName = this.getContentFork2kSvc(typeOfSelectedSvc);
      this.restConflictSvcName = this.getContentForRestK2kSvc(typeOfSelectedSvc);
    }
  }

  getTypeOfK2kService(service) {
    let temp;
    const m365Socs = COMMON_CONSTANTS.SERVICES.K2K_SOCS_M365;
    const quibiSocs = COMMON_CONSTANTS.SERVICES.K2K_SOCS_QUIBI;
    if (service?.isNFLX || service?.isHULU) {
      temp = COMMON_CONSTANTS.CHAR_N;
    } else if (!isNullOrUndefined(service) && m365Socs.indexOf(service.soc) != COMMON_CONSTANTS.DIGITS.MINUS_ONE) {
      temp = COMMON_CONSTANTS.CHAR_M;
    } else if (!isNullOrUndefined(service) && quibiSocs.indexOf(service.soc) != COMMON_CONSTANTS.DIGITS.MINUS_ONE) {
      temp = COMMON_CONSTANTS.CHAR_Q;
    }
    return temp;
  }

  getContentFork2kSvc(type) {
    switch (type) {
      case COMMON_CONSTANTS.CHAR_N:
        return COMMON_CONSTANTS.NETFLIX_TXT;
      case COMMON_CONSTANTS.CHAR_Q:
        return COMMON_CONSTANTS.QUIBI_TXT;
      case COMMON_CONSTANTS.CHAR_M:
        return COMMON_CONSTANTS.MICROSOFT_TXT;
    }
  }

  getContentForRestK2kSvc(type) {
    let k2kSvcContents = [];
    switch (type) {
      case COMMON_CONSTANTS.CHAR_N:
        k2kSvcContents = [COMMON_CONSTANTS.MICROSOFT_TXT, COMMON_CONSTANTS.QUIBI_TXT]
        break;
      case COMMON_CONSTANTS.CHAR_Q:
        k2kSvcContents = [COMMON_CONSTANTS.MICROSOFT_TXT, COMMON_CONSTANTS.NETFLIX_TXT]
        break;
      case COMMON_CONSTANTS.CHAR_M:
        k2kSvcContents = [COMMON_CONSTANTS.NETFLIX_TXT, COMMON_CONSTANTS.QUIBI_TXT]
        break;
    }
    return k2kSvcContents;
  }


  closeGrand(event?:any){​​​​​​​
    let buttonName:any;
    if(!isNullOrUndefined(event) && event.currentTarget.innerText === this.authoringContentData.changeService.cancelTxt){
     buttonName = this.authoringContentData.changeService.cancelTxt;
    }else{
     buttonName = ANALYTICS.CLOSE;
    }
    this.selectedService.isSelected = true;
    if(this.changeRatePlanFlow){
      this.currentSelectedServices = JSON.parse(this._cacheSvc.getFromSessionStorage(RATEPLANSERVICE.CURRENT_SELECTED_SERVICE));
     this.iterateOnCurrentSelectedObj();
      this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.CURRENT_SELECTED_SERVICE, JSON.stringify(this.currentSelectedServices));

      this.updateMainList();
    }
    this.manageLineSvc.close();
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: buttonName ,
      assetType: ANALYTICS.BUTTON,
      modalName:this.authoringContentData.changeService.grandFatherPopupTitle,
    });
    this.pdlService.ifEnabledGenerateModalViewTag({
      eventAction: ANALYTICS.CLOSE,
      modalName: this.authoringContentData.changeService.incompatibleServiceMsg
    });
  }​​​​​​​

  iterateOnCurrentSelectedObj(){
    _.each(this.currentSelectedServices,(currentList)=>{
      if(currentList.soc === this.selectedService.soc){
        currentList.isSelected = this.selectedService.isSelected;
      }
    });
  }
  removeGrand(){​​​​​​​
    if(this.enableMultiPromo && !this.selectedService.isk2k && (!this.selectedService.isNFLX || !this.selectedService.isHULU)){
      /** Trigger promo api for current service*/
      this.manageLineSvc.close();
      this.changeSvc.triggerPromoApi.next(true);
    }else{
      this.selectedService.isSelected = false;
      const temp = _.cloneDeep(this.selectedService);
      const index = this.getIndexOfSocV2(this.currentSelectedServices, temp.soc);
      this.currentSelectedServices.splice(index, COMMON_CONSTANTS.DIGITS.ONE);
      if(this.changeRatePlanFlow){
        this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.CURRENT_SELECTED_SERVICE, JSON.stringify(this.currentSelectedServices));
      }
      this.changeSvc.serviceSelectionChanged.next(true);
      this.manageLineSvc.close();
    }
    if(this.changeRatePlanFlow){
      this.updateMainList();
    }

    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: this.authoringContentData.changeService.removeServiceContinueTxt ,
      assetType: ANALYTICS.BUTTON,
      modalName:this.modalTitle,
    });
  }​​​​​​​
}
